import DateTimeDisplay from '../../components/DateTimeDisplay'
import EntityListTemplate from '../../templates/EntityListTemplate'
import { getGridStringOperators } from '@mui/x-data-grid'

const DataTypesPage = () => {
  const filtersOperators = getGridStringOperators().filter(
    (operator) =>
      operator.value === 'contains' ||
      operator.value === 'equals' ||
      operator.value === 'startsWith',
  )
  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      type: 'string',
      sortable: true,
      filterable: true,
      filtersOperators: filtersOperators,
      width: 200,
      flex: 1,
    },
    {
      field: 'slug',
      headerName: 'Slug',
      type: 'string',
      sortable: false,
      disableColumnMenu: true,
      width: 200,
      flex: 1,
    },
    {
      field: 'subtype',
      headerName: 'Subtype',
      type: 'string',
      sortable: true,
      filterable: true,
      filtersOperators: filtersOperators,
      width: 150,
      flex: 1,
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      type: 'string',
      sortable: true,
      filterable: false,
      width: 200,
      flex: 1,
      renderCell: (row) => (
        <DateTimeDisplay date={new Date(row.value)} showTime={true} />
      ),
    },
    {
      field: 'updatedAt',
      headerName: 'Updated At',
      type: 'datetime',
      sortable: true,
      filterable: false,
      width: 200,
      flex: 1,
      renderCell: (row) => (
        <DateTimeDisplay date={new Date(row.value)} showTime={true} />
      ),
    },
  ]

  const tableProps = {
    initialState: {
      columns: {
        columnVisibilityModel: {
          updatedAt: false,
        },
      },
    },
  }

  return (
    <EntityListTemplate
      entityName="data-types"
      columns={columns}
      title="Data Types"
      defaultSort={[{ field: 'createdAt', sort: 'desc' }]}
      defaultFilters={{ items: [] }}
      tableProps={tableProps}
    />
  )
}

export default DataTypesPage
